import { Outlet } from "react-router-dom";
import MenuAppBarWithDrawer from "../Components/Sidebar/Sidebar";
import ProtectedRoute from "../Routes/PrptectedRoutes";
import { Box } from "@mui/material";


const MainLayout = () => (
  <div>
    <MenuAppBarWithDrawer />
    <Box  sx={{  marginLeft:"250px"}}>
      <ProtectedRoute />
    </Box>
    {/* <Outlet /> */}
  </div>
);

export default MainLayout;
